import NovalueCheck from './NoValueCheck';

export default (value) => {
  if(NovalueCheck(value)) return NovalueCheck(value);

  value = +value;
  const min = 6.0;
  const max = 20.0;

  if(value > max) {
    return {
      title: 'ค่ามากผิดปกติ',
      color: 'red',
      caption: 'ค่ามากผิดปกติ',
      suggest: ''
    };
  } else if(value < min) {
    return {
      title: 'ค่าน้อยผิดปกติ',
      color: 'red',
      caption: 'ค่าน้อยผิดปกติ',
      suggest: ''
    };
  } else {
    return {
      title: 'อยู่ในเกณฑ์ปกติ',
      color: 'green',
      caption: 'อยู่ในเกณฑ์ปกติ',
      suggest: ''
    };
  }
}
